import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
    return (<p>Page not found. Return to the <Link to="/">home page</Link></p>)
}

export default NotFound;